import indexer from "../../../types/genericTypes";
import { IftinpErrorMsgs, IErrorHandler, IftinpValidations } from "../../../types/components/fundTransfer/ftTypes";

export function ftFormValidate(e: any, errorStateFlag: boolean = true) {
	const eTar: any = e.target || e;
	let fieldValidState: boolean = true;
	let returnObj: IErrorHandler = { ErrorState: false, key: "", name: "" };
	if (eTar !== undefined) {
		const validations: indexer = JSON.parse(eTar.dataset.validation as string);
		let valKeys: Array<string> = Object.keys(validations),
			invalidKey: string = "";
		for (let i = 0; i < valKeys.length; i++) {
			let key: keyof IftinpValidations;
			key = valKeys[i] as keyof IftinpValidations;

			//used if instead of switch to set error state on pripority basis

			//validations which are dependent on value
			if (eTar.value) {
				if (key === "max" && parseFloat(eTar.value) > parseFloat(validations[key])) {
					fieldValidState = false;
					invalidKey = key;
				}

				if (key === "min" && parseFloat(eTar.value) < parseFloat(validations[key])) {
					fieldValidState = false;
					invalidKey = key;
				}

				if (key === "regEx") {
					var regEx = new RegExp(validations[key]);
					if (!regEx.test(eTar.value)) {
						fieldValidState = false;
						invalidKey = key;
					}
				}
			}

			if (key === "required" && validations[key] && !eTar.value && parseFloat(eTar.value) !== 0) {
				fieldValidState = false;
				invalidKey = key;
			}
		}
		//paragraph element where error and info messages are displayed
		const errMsg = document.querySelector(".formInpCont .info") as HTMLParagraphElement;
		//errorStateFlag flag used to reset all the error states to false
		if (fieldValidState) {
			eTar.dataset["error"] = "false";
			errMsg.dataset["error"] = "false";
		} else if (errorStateFlag) {
			eTar.dataset["error"] = "true";
			errMsg.dataset["error"] = "true";
		}
		returnObj = { ErrorState: !fieldValidState, key: invalidKey as keyof IftinpErrorMsgs, name: eTar.name };
	}
	return returnObj;
}
